import apiClient, { unwrap } from './client'
import type { SendLog } from './types'

export const sendLogsApi = {
  list() {
    return unwrap<SendLog[]>(apiClient.get('/send-logs'))
  },
}
